import React, { createContext, useContext, useState } from 'react';
import PropTypes from 'prop-types';

import {
  PRIORITY,
  PROGRAM,
  PROGRAM_DEPARTMENT,
  PROGRAM_DIVISION,
  REQUEST,
  USER_GROUP,
} from '../static/keyWords.js';

const NameConventionsContext = createContext(null);

export const NameConventionsProvider = ({ children }) => {
  const [nameConventions, setNameConventions] = useState(getDefaultNameConventions());

  return (
    <NameConventionsContext.Provider value={{ nameConventions, setNameConventions }}>
      {children}
    </NameConventionsContext.Provider>
  );
};

NameConventionsProvider.propTypes = {
  children: PropTypes.node,
};

export const useNameConventions = () => {
  const context = useContext(NameConventionsContext);

  if (context === undefined || context === null) {
    throw new Error('useNameConventions must be used within a NameConventionsProvider');
  }

  return context;
};

const getDefaultNameConventions = () => ({
  [USER_GROUP]: {
    name: USER_GROUP,
    alias: 'User group',
    pluralFormAlias: 'User groups',
    description:
      'This is a categorization to organize programs and line items that allows users to easily see and group programs and line items together.',
  },
  [PROGRAM_DEPARTMENT]: {
    name: PROGRAM_DEPARTMENT,
    alias: 'Program department',
    pluralFormAlias: 'Program departments',
    description:
      'This is the higher of two fields to organize the program inventory into an organizationally meaningful hierarchy.',
  },
  [PROGRAM_DIVISION]: {
    name: PROGRAM_DIVISION,
    alias: 'Program division',
    pluralFormAlias: 'Program divisions',
    description:
      'This is the lower of two fields to organize the program inventory into an organizationally meaningful hierarchy.',
  },
  [PRIORITY]: {
    name: PRIORITY,
    alias: 'Priority',
    pluralFormAlias: 'Priorities',
    description:
      'This is a scoring category or priority for every organization, usually reflected in a strategic plan or guiding document.',
  },
  [PROGRAM]: {
    name: PROGRAM,
    alias: 'Program',
    pluralFormAlias: 'Programs',
    description:
      'This is a description of the service(s) offered by your organization; this is the foundational data layer upon which everything else, including budget requests, will be built.',
  },
  [REQUEST]: {
    name: REQUEST,
    alias: 'Request',
    pluralFormAlias: 'Requests',
    description:
      'This how your organization refers to budget requests, proposals, or submissions.',
  },
});

